import React from "react";
import { Text, Flex, Center, VStack } from "@chakra-ui/react";

import colors from "app/colors";
import Link from "modules/layouts/_shared/link";
import moment from "moment";
import {
  GooglePlayStoreIcon,
  IosAppStoreIcon,
  LogoAppStoreLinksIcon,
} from "modules/icons";

const MobilePage = () => (
  <Flex h="100dvh">
    <Center w="full">
      <VStack w="full">
        <LogoAppStoreLinksIcon boxSize={150} />
        <Text fontFamily="Arial" fontSize={27} fontWeight={700} pt={30}>
          Download Synco!
        </Text>
        <Text
          pb={30}
          color={colors.gray50}
          fontWeight={600}
          fontSize={18}
          textAlign="center"
        >
          For the best experience
          <br /> download the mobile app.
        </Text>
        <Link href="https://apps.apple.com/app/1667473666">
          <IosAppStoreIcon />
        </Link>
        <Link href="https://play.google.com/store/apps/details?id=com.teamsynco.chat">
          <GooglePlayStoreIcon />
        </Link>
        <Link href="https://teamsynco.com" py={30}>
          <Text color={colors.orangePrimary} fontWeight={700}>
            {"> "}More Information on teamsynco.com
          </Text>
        </Link>

        <Text color={colors.gray50}>
          Copyright © {moment().format("YYYY")} CakeTech, Inc. All rights
          reserved.
        </Text>
      </VStack>
    </Center>
  </Flex>
);

MobilePage.prefersFullScreenLayout = true;

export default MobilePage;
